import React, { useState } from "react";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Table from "components/Table/Table.jsx";
import CustomInput from "components/CustomInput/CustomInputValidate";
import { cloneJ } from "../../shared/utility";
import Button from "../../components/CustomButtons/Button";
import { IconButton } from "@material-ui/core";
import { getSum } from "./CommissionSplitsLogic";
import NotificationAsk from "../../components/Notification/NotificationAsk";
import CustomCRMEditor from "../../components/CustomDialog/CustomCRMEditor";
import CustomSelect from "../../components/CustomSelect/CustomSelect";

const checkAssociateValues = (arr) => {
    for (let i = 0; i < arr.length; i++) {
        const a = arr[i];
        if (!a.commission_percent || a.commission_percent == 0) {
            return false;
        }
    }
    return true;
}

const Step2 = (props) => {
    const [askBeforeDelete, setAskBeforeDelete] = useState(-1);
    const [edit, setEdit] = useState(null);
    const { dataObj, updateDataObj, setOpenedChooseModal, setQueryFor, currentUserIsSubmitter, currentUserIsAnAgentApprover, setOpenedChooseAssociateModal } = props;
    const lessee_sum = getSum(dataObj.contacts, null, 'Lessee');
    const lessor_sum = getSum(dataObj.contacts, null, 'Lessor');
    const isCompleteTab = props.parentTab === 'my_completed' || props.parentTab === 'all_completed' ? 
        true : false;
    const sideless = dataObj.contacts.map((a,x) => {
        a.original_index = x;
        return a;
    }).filter(a => {
        if (!a.referral_type) return true;
    });
    console.log('CS Step2', lessee_sum, lessor_sum);
    return <div className={currentUserIsAnAgentApprover || props.action === 'view' ? 'no-click' : ''}>
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <h3>Associates / Commission Splits</h3>
                {(props.parentTab !== 'my_completed' && props.parentTab !== 'all_completed') && <div>
                    {currentUserIsSubmitter && <Button color="primary" onClick={() => {
                        setQueryFor({
                            title: 'Select Contacts / Commission Splits',
                            label: 'Select Contacts / Commission Splits',
                            type: 'contacts'
                        })
                        // setOpenedChooseModal(true)
                        setOpenedChooseAssociateModal(true)
                    }}>ADD NEW</Button>}
                </div>}
            </GridItem>

            <GridItem xs={12} sm={12} md={12}>
            {sideless.length > 0 && <div>
                <h3>Choose a Side</h3>
            <Table
                tableHeaderColor="primary"
                tableHead={['','Name','Email','Commission %','Remove']}
                tableData={sideless.map((a,i) => {
                    console.log('asas', a);
                    return [
                        <div>
                            <CustomSelect 
                                options={['Lessee', 'Lessor'/*, 'Both'*/]}
                                choose={(e) => {
                                    updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                        console.log('xxx', j, x.original_index);
                                        if (a.original_index === x.original_index) {
                                            x.referral_type = e;
                                        }
                                        return x;
                                    })); 
                                }}
                                default={a.referral_type}
                            />
                            {!a.referral_type && <div style={{color:'red'}}>Required</div>}
                        </div>,
                        <div>
                            <div>
                                <CustomInput 
                                    value={a.first_name}
                                    label="First Name"
                                    onClick={() => {
                                        if (a.contact_id) {
                                            setEdit({
                                                value: a.first_name,      
                                                type: 'contact',       
                                                field: 'first_name',      
                                                fieldType: 'input',  
                                                label: 'First Name',      
                                                id: a.contact_id,         
                                                chooseVal: (chosenVal) => {
                                                    updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                                        if (a.original_index === x.original_index) {
                                                            x.first_name = chosenVal;
                                                        }
                                                        return x;
                                                    })); 
                                                    setEdit(null); 
                                                }
                                            });
                                        }
                                    }}
                                />
                            </div>
                            <div>
                                <CustomInput 
                                    value={a.last_name}
                                    label="Last Name"
                                    onClick={() => {
                                        if (a.contact_id) {
                                            setEdit({
                                                value: a.last_name,      
                                                type: 'contact',       
                                                field: 'last_name',      
                                                fieldType: 'input',  
                                                label: 'Last Name',      
                                                id: a.contact_id,         
                                                chooseVal: (chosenVal) => {
                                                    updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                                        if (a.original_index === x.original_index) {
                                                            x.last_name = chosenVal;
                                                        }
                                                        return x;
                                                    })); 
                                                    setEdit(null); 
                                                }
                                            });
                                        }
                                    }}
                                />
                            </div>
                            {(a.dba_name && a.dba_active) && <div>
                                <CustomInput 
                                    value={a.dba_name}
                                    label="DBA Name"
                                    onClick={() => {
                                        setEdit({
                                            value: a.dba_id,      
                                            type: 'contact_dba',       
                                            field: 'name',      
                                            fieldType: 'select',  
                                            label: 'Contact DBA Name',      
                                            id: a.dba_id, 
                                            contact_id: a.contact_id,
                                            chooseVal: (chosenVal, chosenName) => { 
                                                updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                                    if (a.original_index === x.original_index) {
                                                        x.dba_id = chosenVal;
                                                        x.dba_name = chosenName;
                                                    }
                                                    return x;
                                                })); 
                                                setEdit(null); 
                                            },
                                        })
                                    }}
                                />
                            </div>}
                            
                            <div><strong>{a.email ? null : <div className="red-text">No Email</div>}</strong></div>
                        </div>,
                        <div>
                            {a.company_contact_id && <div><strong>Company Email</strong></div>}
                            <CustomInput 
                                value={a.email}
                                label="Email"
                                onClick={() => {
                                    if (a.company_id && a.company_contact_id) {
                                        setEdit({
                                            value: a.email,      
                                            type: 'company_contact',       
                                            field: 'email',      
                                            fieldType: 'input',  
                                            label: 'Email',      
                                            id: a.company_contact_id,         
                                            chooseVal: (chosenVal) => {
                                                updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                                    if (a.original_index === x.original_index) {
                                                        x.email = chosenVal;
                                                    }
                                                    return x;
                                                }));
                                                setEdit(null); 
                                            }
                                        });
                                    } else if (a.contact_id) {
                                        setEdit({
                                            value: a.email,      
                                            type: 'contact',       
                                            field: 'email',      
                                            fieldType: 'input',  
                                            label: 'Email',      
                                            id: a.contact_id,         
                                            chooseVal: (chosenVal) => {
                                                updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                                    if (x.original_index === a.original_index) {
                                                        x.email = chosenVal;
                                                    }
                                                    return x;
                                                })); 
                                                setEdit(null); 
                                            }
                                        });
                                    }
                                }}
                            />
                        </div>,
                        <CustomInput 
                            label="Enter %"
                            value={a.commission_percent}
                            disabled={currentUserIsSubmitter ? false : true}
                            onChange={(e) => {
                                const newData = cloneJ(dataObj);
                                newData.contacts = newData.contacts.map((c,x) => {
                                    console.log('cc', c, x);
                                    if (a.original_index === c.original_index) {
                                        c.commission_percent = e.target.value;
                                        return c;
                                    }
                                    return c;
                                })
                                updateDataObj('contacts', newData.contacts);
                            }}
                            number_only={true}
                        />,
                        !isCompleteTab && <IconButton
                            disabled={currentUserIsSubmitter ? false : true}
                            onClick={() => {
                                setAskBeforeDelete(a.original_index);
                            }}
                        ><i className="fa fa-trash" style={{fontSize:14}}></i></IconButton>
                    ]
                }).concat([
                    ['',
                    '',
                    lessee_sum > 0 ? 'TOTAL LESSEE' : '',
                    lessee_sum > 0 ? <div style={{color:lessee_sum === 100 ? 'green' : 'red'}}>{lessee_sum} %</div> : '',
                    ''],
                ])}
                coloredColls={[1]}
                colorsColls={["primary"]}
            />
            <hr />
            </div>}
            <h3>Lessee</h3>
            <Table
                tableHeaderColor="primary"
                tableHead={['','Name','Email','Commission %','Remove']}
                tableData={dataObj.contacts.map((a,x) => {
                    a.original_index = x;
                    return a;
                }).filter(a => {
                    if (a.referral_type === 'Lessee' || a.referral_type === 'Both') return true;
                }).map((a,i) => {
                    console.log('asas', a);
                    return [
                        <div>
                            <CustomSelect 
                                options={['Lessee', 'Lessor'/*, 'Both'*/]}
                                choose={(e) => {
                                    updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                        console.log('xxx', j, x.original_index);
                                        if (a.original_index === x.original_index) {
                                            x.referral_type = e;
                                        }
                                        return x;
                                    })); 
                                }}
                                default={a.referral_type}
                            />
                            {!a.referral_type && <div style={{color:'red'}}>Required</div>}
                        </div>,
                        <div>
                            <div>
                                <CustomInput 
                                    value={a.first_name}
                                    label="First Name"
                                    onClick={() => {
                                        if (a.contact_id) {
                                            setEdit({
                                                value: a.first_name,      
                                                type: 'contact',       
                                                field: 'first_name',      
                                                fieldType: 'input',  
                                                label: 'First Name',      
                                                id: a.contact_id,         
                                                chooseVal: (chosenVal) => {
                                                    updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                                        if (a.original_index === x.original_index) {
                                                            x.first_name = chosenVal;
                                                        }
                                                        return x;
                                                    })); 
                                                    setEdit(null); 
                                                }
                                            });
                                        }
                                    }}
                                />
                            </div>
                            <div>
                                <CustomInput 
                                    value={a.last_name}
                                    label="Last Name"
                                    onClick={() => {
                                        if (a.contact_id) {
                                            setEdit({
                                                value: a.last_name,      
                                                type: 'contact',       
                                                field: 'last_name',      
                                                fieldType: 'input',  
                                                label: 'Last Name',      
                                                id: a.contact_id,         
                                                chooseVal: (chosenVal) => {
                                                    updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                                        if (a.original_index === x.original_index) {
                                                            x.last_name = chosenVal;
                                                        }
                                                        return x;
                                                    })); 
                                                    setEdit(null); 
                                                }
                                            });
                                        }
                                    }}
                                />
                            </div>
                            {(a.dba_name && a.dba_active) && <div>
                                <CustomInput 
                                    value={a.dba_name}
                                    label="DBA Name"
                                    onClick={() => {
                                        setEdit({
                                            value: a.dba_id,      
                                            type: 'contact_dba',       
                                            field: 'name',      
                                            fieldType: 'select',  
                                            label: 'Contact DBA Name',      
                                            id: a.dba_id, 
                                            contact_id: a.contact_id,
                                            chooseVal: (chosenVal, chosenName) => { 
                                                updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                                    if (a.original_index === x.original_index) {
                                                        x.dba_id = chosenVal;
                                                        x.dba_name = chosenName;
                                                    }
                                                    return x;
                                                })); 
                                                setEdit(null); 
                                            },
                                        })
                                    }}
                                />
                            </div>}
                            
                            <div><strong>{a.email ? null : <div className="red-text">No Email</div>}</strong></div>
                        </div>,
                        <div>
                            {a.company_contact_id && <div><strong>Company Email</strong></div>}
                            <CustomInput 
                                value={a.email}
                                label="Email"
                                onClick={() => {
                                    if (a.company_id && a.company_contact_id) {
                                        setEdit({
                                            value: a.email,      
                                            type: 'company_contact',       
                                            field: 'email',      
                                            fieldType: 'input',  
                                            label: 'Email',      
                                            id: a.company_contact_id,         
                                            chooseVal: (chosenVal) => {
                                                updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                                    if (a.original_index === x.original_index) {
                                                        x.email = chosenVal;
                                                    }
                                                    return x;
                                                }));
                                                setEdit(null); 
                                            }
                                        });
                                    } else if (a.contact_id) {
                                        setEdit({
                                            value: a.email,      
                                            type: 'contact',       
                                            field: 'email',      
                                            fieldType: 'input',  
                                            label: 'Email',      
                                            id: a.contact_id,         
                                            chooseVal: (chosenVal) => {
                                                updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                                    if (x.original_index === a.original_index) {
                                                        x.email = chosenVal;
                                                    }
                                                    return x;
                                                })); 
                                                setEdit(null); 
                                            }
                                        });
                                    }
                                }}
                            />
                        </div>,
                        <CustomInput 
                            label="Enter %"
                            value={a.commission_percent}
                            disabled={currentUserIsSubmitter ? false : true}
                            onChange={(e) => {
                                const newData = cloneJ(dataObj);
                                newData.contacts = newData.contacts.map((c,x) => {
                                    console.log('cc', c, x);
                                    if (a.original_index === c.original_index) {
                                        c.commission_percent = e.target.value;
                                        return c;
                                    }
                                    return c;
                                })
                                updateDataObj('contacts', newData.contacts);
                            }}
                            number_only={true}
                        />,
                        !isCompleteTab && <IconButton
                            disabled={currentUserIsSubmitter ? false : true}
                            onClick={() => {
                                setAskBeforeDelete(a.original_index);
                            }}
                        ><i className="fa fa-trash" style={{fontSize:14}}></i></IconButton>
                    ]
                }).concat([
                    ['',
                    '',
                    lessee_sum > 0 ? 'TOTAL LESSEE' : '',
                    lessee_sum > 0 ? <div style={{color:lessee_sum === 100 ? 'green' : 'red'}}>{lessee_sum} %</div> : '',
                    ''],
                ])}
                coloredColls={[1]}
                colorsColls={["primary"]}
            />
            <hr />
            <h3>Lessor</h3>
            <Table
                tableHeaderColor="primary"
                tableHead={['','Name','Email','Commission %','Remove']}
                tableData={dataObj.contacts.map((a,x) => {
                    a.original_index = x;
                    return a;
                }).filter(a => {
                    if (a.referral_type === 'Lessor' || a.referral_type === 'Both') return true;
                }).map((a,i) => {
                    return [
                        <div>
                            <CustomSelect 
                                options={['Lessee', 'Lessor'/*, 'Both'*/]}
                                choose={(e) => {
                                    updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                        if (a.original_index === x.original_index) {
                                            x.referral_type = e;
                                        }
                                        return x;
                                    })); 
                                }}
                                default={a.referral_type}
                            />
                            {!a.referral_type && <div style={{color:'red'}}>Required</div>}
                        </div>,
                        <div>
                            <div>
                                <CustomInput 
                                    value={a.first_name}
                                    label="First Name"
                                    onClick={() => {
                                        if (a.contact_id) {
                                            setEdit({
                                                value: a.first_name,      
                                                type: 'contact',       
                                                field: 'first_name',      
                                                fieldType: 'input',  
                                                label: 'First Name',      
                                                id: a.contact_id,         
                                                chooseVal: (chosenVal) => {
                                                    updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                                        if (a.original_index === x.original_index) {
                                                            x.first_name = chosenVal;
                                                        }
                                                        return x;
                                                    })); 
                                                    setEdit(null); 
                                                }
                                            });
                                        }
                                    }}
                                />
                            </div>
                            <div>
                                <CustomInput 
                                    value={a.last_name}
                                    label="Last Name"
                                    onClick={() => {
                                        if (a.contact_id) {
                                            setEdit({
                                                value: a.last_name,      
                                                type: 'contact',       
                                                field: 'last_name',      
                                                fieldType: 'input',  
                                                label: 'Last Name',      
                                                id: a.contact_id,         
                                                chooseVal: (chosenVal) => {
                                                    updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                                        if (a.original_index === x.original_index) {
                                                            x.last_name = chosenVal;
                                                        }
                                                        return x;
                                                    })); 
                                                    setEdit(null); 
                                                }
                                            });
                                        }
                                    }}
                                />
                            </div>
                            {(a.dba_name && a.dba_active) && <div>
                                <CustomInput 
                                    value={a.dba_name}
                                    label="DBA Name"
                                    onClick={() => {
                                        setEdit({
                                            value: a.dba_id,      
                                            type: 'contact_dba',       
                                            field: 'name',      
                                            fieldType: 'select',  
                                            label: 'Contact DBA Name',      
                                            id: a.dba_id, 
                                            contact_id: a.contact_id,
                                            chooseVal: (chosenVal, chosenName) => { 
                                                updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                                    if (a.original_index === x.original_index) {
                                                        x.dba_id = chosenVal;
                                                        x.dba_name = chosenName;
                                                    }
                                                    return x;
                                                })); 
                                                setEdit(null); 
                                            },
                                        })
                                    }}
                                />
                            </div>}
                            
                            <div><strong>{a.email ? null : <div className="red-text">No Email</div>}</strong></div>
                        </div>,
                        <div>
                            {a.company_contact_id && <div><strong>Company Email</strong></div>}
                            <CustomInput 
                                value={a.email}
                                label="Email"
                                onClick={() => {
                                    if (a.company_id && a.company_contact_id) {
                                        setEdit({
                                            value: a.email,      
                                            type: 'company_contact',       
                                            field: 'email',      
                                            fieldType: 'input',  
                                            label: 'Email',      
                                            id: a.company_contact_id,         
                                            chooseVal: (chosenVal) => {
                                                updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                                    if (a.original_index === x.original_index) {
                                                        x.email = chosenVal;
                                                    }
                                                    return x;
                                                }));
                                                setEdit(null); 
                                            }
                                        });
                                    } else if (a.contact_id) {
                                        setEdit({
                                            value: a.email,      
                                            type: 'contact',       
                                            field: 'email',      
                                            fieldType: 'input',  
                                            label: 'Email',      
                                            id: a.contact_id,         
                                            chooseVal: (chosenVal) => {
                                                updateDataObj('contacts', dataObj.contacts.map((x,j) => {
                                                    if (a.original_index === x.original_index) {
                                                        x.email = chosenVal;
                                                    }
                                                    return x;
                                                })); 
                                                setEdit(null); 
                                            }
                                        });
                                    }
                                }}
                            />
                        </div>,
                        <CustomInput 
                            label="Enter %"
                            value={a.commission_percent}
                            disabled={currentUserIsSubmitter ? false : true}
                            onChange={(e) => {
                                const newData = cloneJ(dataObj);
                                newData.contacts = newData.contacts.map((c,x) => {
                                    if (a.original_index === c.original_index) {
                                        c.commission_percent = e.target.value;
                                        return c;
                                    }
                                    return c;
                                })
                                updateDataObj('contacts', newData.contacts);
                            }}
                            number_only={true}
                        />,
                        !isCompleteTab && <IconButton
                            disabled={currentUserIsSubmitter ? false : true}
                            onClick={() => {
                                setAskBeforeDelete(a.original_index);
                            }}
                        ><i className="fa fa-trash" style={{fontSize:14}}></i></IconButton>
                    ]
                }).concat([
                    ['',
                    '',
                    lessor_sum > 0 ? 'TOTAL LESSOR' : '',
                    lessor_sum > 0 ? <div style={{color:lessor_sum === 100 ? 'green' : 'red'}}>{lessor_sum} %</div> : '',
                    ''],
                ])}
                coloredColls={[1]}
                colorsColls={["primary"]}
            />
            </GridItem>
        </GridContainer>

        {askBeforeDelete !== -1 && <NotificationAsk 
            title="Are you sure?"
            message="Do you want to remove this contact/commission split?"
            success={() => {
                if (props.parentTab === 'my_completed' || props.parentTab === 'all_completed') {
                    setAskBeforeDelete(-1);
                    return;
                }
                const newData = cloneJ(dataObj);
                newData.contacts = newData.contacts.filter((c,x) => {
                    if (x === askBeforeDelete) {
                        return false;
                    }
                    return true;
                })
                updateDataObj('contacts', newData.contacts);
                setAskBeforeDelete(-1);
            }}
            open={askBeforeDelete !== -1 ? true : false}
            close={() => {
                setAskBeforeDelete(-1);
            }}
        />}

        {edit !== null && <CustomCRMEditor 
            {...edit}
            close={() => {
                setEdit(null)
            }}
        />}
    </div>
}

export default Step2;